module Meevo.Plugins.GiftCardIntegration {
    "use strict";

    /**
    * Main Section of GiftCardIntegration 
    */
    export class MainSection extends Meevo.Components.CommonClasses.CommonSectionBase {
        protected modalService: Meevo.Components.Modal.IModalService;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey?: string
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey);
            this.modalService = modalService;
        }

        addNewBin(): void {
            if (!this.isReadonly) {
                this.dataService.getTemplate(this.baseEndpoint)
                    .then((response: Meevo.Model.GiftCardExternalBin) => {
                        (<Meevo.Model.GiftCardExternalBinContainer>this.model).externalBins.push(response);
                    });
            }
        }

        deleteBin(bin: any): void {
            if (!this.isReadonly) {
                let countBinsSaved = this.model.externalBins.filter((item) => item.objectState === 0);
                let countBinsNotSaved = this.model.externalBins.filter((item) => item.objectState === 2026 && item.prefix != '' && item.prefix);

                if ((countBinsSaved.length <= 1 && countBinsNotSaved.length == 0 && (bin.prefix != '' && bin.prefix))
                    || (countBinsSaved.length == 0 && countBinsNotSaved.length <= 1 && (bin.prefix != '' && bin.prefix))
                    || (countBinsSaved.length <= 1 && countBinsNotSaved.length == 0 && !bin.prefix && bin.objectState === 0)
                    || (countBinsSaved.length == 0 && countBinsNotSaved.length == 0 && !bin.prefix && bin.objectState === 2026)) {
                    this.modalService.alert("MESSAGE_INTEGRATION_BIN", Components.Modal.ModalTranslationModes.Translate)
                } else {
                    this.modalService.confirm("MESSAGE_DELETE_CONFIRMATION").then((confirmResult: boolean) => {
                        if (confirmResult) {
                            var vm = (<Meevo.Model.GiftCardExternalBinContainer>this.model);
                            vm.externalBins = _.reject(vm.externalBins,
                                (binElement: Meevo.Model.GiftCardExternalBin) => {
                                    return binElement.prefix === bin.prefix;
                                });
                        }
                    });
                }
            }
        }

        get isReadonly(): boolean {
            return this.mode === Meevo.Model.MaintenanceFormState.Readonly;
        }
    }
}